import { DEFAULT_SETTINGS, OTHER, VIDEO_CONSULTATION, VIDEO_SPECIALIST_ASSESSMENT } from 'FRONTEND/utils/constants';
import { API_LOCAL_SETTINGS_PATH } from 'FRONTEND/utils/routes';
import { getDurationSettingKey } from 'FRONTEND/utils/stringFormatting';

export const FORMATTED_TO_RAW_SETTING_KEY_MAP = {
  [getDurationSettingKey(VIDEO_SPECIALIST_ASSESSMENT)]: 'telestaff_duration',
  [getDurationSettingKey(VIDEO_CONSULTATION)]: 'teleconsultation_duration',
  [getDurationSettingKey(OTHER)]: 'other_appointment_duration',
  id: 'user_id',
  consultations_comments_only: 'consultations_comments_only',
};

/**
 * Convert settings received from back-end into front-end-friendly ones (mostly case change)
 * @param rawSettings
 * @param {Boolean} shouldFillUp=false - Whether default values should be set for undefined settings.
 * @returns {{id: *}}
 */
export const formatSettings = (rawSettings, shouldFillUp) => {
  return Object.entries(DEFAULT_SETTINGS).reduce((formattedSettings, [settingKey, defaultSettingValue]) => {
    if (shouldFillUp) {
      formattedSettings[settingKey] = rawSettings[FORMATTED_TO_RAW_SETTING_KEY_MAP[settingKey]] ?? defaultSettingValue;
    } else if (rawSettings[FORMATTED_TO_RAW_SETTING_KEY_MAP[settingKey]] != null) {
      formattedSettings[settingKey] = rawSettings[FORMATTED_TO_RAW_SETTING_KEY_MAP[settingKey]];
    }
    return formattedSettings;
  }, { id: rawSettings.user_id || rawSettings.id });
};

/**
 * Convert front-end settings into back-end ones (mostly case change) in order to make them fit the API format
 * @param settings
 * @returns {{}}
 */
const buildSettings = (settings) => {
  return Object.entries(settings).reduce((builtSettings, [settingKey, settingValue]) => {
    builtSettings[FORMATTED_TO_RAW_SETTING_KEY_MAP[settingKey]] = settingValue;
    return builtSettings;
  }, {});
};

export const getSettings = async() => {
  const rawExpertSettingList = await fetch(API_LOCAL_SETTINGS_PATH, {
    headers: {
      Accept: 'application/json',
      'X-CSRF-Token': window.CSRFToken,
    },
  }).then(async(response) => {
    return response.json();
  });
  return rawExpertSettingList.map(formatSettings);
};

export const postSettings = async({ expertId, settings }) => {
  const builtSettings = buildSettings({ id: expertId, ...settings });
  const body = JSON.stringify(builtSettings);
  const res = await fetch(API_LOCAL_SETTINGS_PATH, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Prefer: 'return=representation',
      'X-CSRF-Token': window.CSRFToken,
    },
    body,
  });
  if (!res.ok) {
    const error = new Error('Error while posting settings');
    console.error(error.message, res.status, res.statusText);
    throw error;
  }
  return formatSettings(builtSettings, false);
};
